import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AnimationController, MenuController, PopoverController } from '@ionic/angular';
import { AuthService } from 'src/app/core/auth.service';
import { UserService } from 'src/app/shared-lib/domains/user';
import { AppService } from '../app.service';
import { CartService } from '../cart.service';
import { MenuPopoverComponent } from '../menu-popover/menu-popover.component';

@Component({
  selector: 'app-desktop-header',
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss'],
  standalone: false
})
export class DesktopHeaderComponent implements OnInit {

  @Output() showFaqSidebar = new EventEmitter<boolean>();
  @Input() disabled: boolean = false;

  constructor(
    public cartService: CartService,
    public userService: UserService,
    public popoverController: PopoverController,
    public appService: AppService,
    public router: Router,
    private animationCtrl: AnimationController,
    private menuCtrl: MenuController,
    public authService: AuthService
  ) {
  }

  ngOnInit() {
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: MenuPopoverComponent,
      cssClass: 'popover-menu',
      event: ev,
      translucent: true,
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
  }

  toStationery() {
    let queryParams = { o: 'relevance', d: 'desc' };
    let navigationExtras: NavigationExtras = {
      queryParams
    };
    this.router.navigate(['papeleria/catalogo'], navigationExtras);
  }

  abrirFaqSidebar() {
    this.menuCtrl.open('faqs-menu');
  }
}
